import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GCParcel } from '../../../../models/agrorendement-genconsole.model';
import { isGenConsoleFormatSupported, isGenConsoleModelSupported, isGenConsoleVersionSupported } from './utils';
import { TranslatePipe } from '../../../../pipes/translate.pipe';

@Component({
  standalone: true,
  selector: 'ar-genconsole-launcher-cmp',
  templateUrl: './genconsole.launcher.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, TranslatePipe],
  providers: [],
})
export class ARGenConsoleLauncherComponent implements OnInit, AfterViewInit {
  @Input()
  culture: string;

  @Input()
  oadName: string;

  @Input()
  resultPageLink: string;

  @Input()
  parcels: Array<GCParcel>;

  constructor(private router: Router) {}

  ngOnInit() {}

  ngAfterViewInit() {}

  hasFormatUnsupported() {
    for (const parcel of this.parcels) {
      if (!isGenConsoleFormatSupported(parcel.console.consoleFormatType)) {
        return true;
      }
    }
    return false;
  }

  hasConsoleUnsupported() {
    for (const parcel of this.parcels) {
      if (!isGenConsoleModelSupported(parcel.console.consoleType)) {
        return true;
      }
    }
    return false;
  }

  hasVersionUnsupported() {
    for (const parcel of this.parcels) {
      if (!isGenConsoleVersionSupported(parcel.console.consoleVersion)) {
        return true;
      }
    }
    return false;
  }
}
